/**
 * Humaniza codigo tecnico para exibicao. EM_EXECUCAO vira "Em execucao",
 * assinatura_pendente vira "Assinatura pendente".
 *
 * So aparencia: nao traduz, nao decide nada de negocio. Serve ao selo de
 * situacao e a qualquer lugar que precise mostrar um enum cru de forma legivel.
 */

/** Palavras que ficam em minuscula no meio da frase (mas nao no inicio). */
const MINUSCULAS = new Set(['de', 'da', 'do', 'e', 'em', 'a', 'o', 'por', 'para']);

export function humanizeLabel(codigo: string): string {
  if (!codigo) {
    return '';
  }

  const palavras = codigo
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .split(' ');

  return palavras
    .map((palavra, indice) => {
      if (indice > 0 && MINUSCULAS.has(palavra)) {
        return palavra;
      }
      return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    })
    .join(' ');
}
